exports = module.exports = require("../../../../../tools/web-builder/node_modules/css-loader/dist/runtime/api.js")(true);
// Module
exports.push([module.id, "", "",{"version":3,"sources":[],"names":[],"mappings":"","file":"map-legend.scss"}]);

